import React from 'react';

const audiences = [
  {
    title: 'Personas con ansiedad o bloqueo',
    description: 'Si sientes que la ansiedad dirige tu vida, te bloqueas ante decisiones o tu mente no para.',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    ),
  },
  {
    title: 'Crisis vitales',
    description: 'Duelo, rupturas, trauma, cambios importantes o etapas de incertidumbre que necesitan acompañamiento.',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
      </svg>
    ),
  },
  {
    title: 'Procesos de identidad y autoestima',
    description: 'Si buscas conocerte mejor, trabajar tu autoestima o encontrar más coherencia con quien eres.',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    ),
  },
  {
    title: 'Colectivo LGTBIQA+',
    description: 'Personas que buscan un espacio afirmativo donde su identidad y orientación no se cuestionen.',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    ),
  },
  {
    title: 'Jóvenes adultos en transición',
    description: 'Si estás en un momento de cambio: fin de estudios, primeros trabajos, independencia o redefinición vital.',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
      </svg>
    ),
  },
];

export default function Destinatarios() {
  return (
    <section id="destinatarios" className="section-padding bg-blush">
      <div className="container-narrow">
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-medium tracking-widest text-[var(--color-inerva-forest)] opacity-70 mb-4 uppercase">
            ¿Para quién es Inerva?
          </span>
          <h2 className="mb-4">A quién acompañamos</h2>
          <p className="text-[var(--color-inerva-text-light)] max-w-2xl mx-auto">
            Inerva es para ti si te identificas con alguna de estas situaciones.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {audiences.slice(0, 3).map((a, i) => (
            <div key={i} className="bg-white rounded-[var(--radius-xl)] p-8 border border-[rgba(61,79,61,0.08)]">
              <div className="w-14 h-14 rounded-full bg-[var(--color-inerva-mint)] flex items-center justify-center text-[var(--color-inerva-forest)] mb-5">
                {a.icon}
              </div>
              <h3 className="text-xl mb-3 font-serif">{a.title}</h3>
              <p className="text-[var(--color-inerva-text-light)] text-sm leading-relaxed">{a.description}</p>
            </div>
          ))}
        </div>
        <div className="flex flex-wrap justify-center gap-6 mt-6">
          {audiences.slice(3).map((a, i) => (
            <div key={i + 3} className="bg-white rounded-[var(--radius-xl)] p-8 border border-[rgba(61,79,61,0.08)] w-full sm:w-[calc(50%-0.75rem)] lg:w-[calc(33.333%-1rem)]">
              <div className="w-14 h-14 rounded-full bg-[var(--color-inerva-mint)] flex items-center justify-center text-[var(--color-inerva-forest)] mb-5">
                {a.icon}
              </div>
              <h3 className="text-xl mb-3 font-serif">{a.title}</h3>
              <p className="text-[var(--color-inerva-text-light)] text-sm leading-relaxed">{a.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
